// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHero-module--container--noK74","text":"PageHero-module--text--34COT","svgContainer":"PageHero-module--svgContainer--14KZ_"};